import { getAnalytics, logEvent, Analytics } from 'firebase/analytics';
import { Cookies } from 'react-cookie-consent';

import { app } from './firebase-config';

class AnalyticsService {
  private analytics: Analytics | null = null;

  init() {
    const consent = Cookies.get('analytics') !== 'false';

    if (consent) {
      if (!this.analytics) {
        this.analytics = getAnalytics(app);
      }
    } else {
      this.analytics = null;
    }
  }

  log(event: string, params?: Record<string, any>) {
    if (this.analytics) {
      logEvent(this.analytics, event, params);
    }
  }
}

export const analyticsService = new AnalyticsService();
